import React from 'react';


const InteroperabilityLayerSection = () => {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
      <div className="max-w-7xl mx-auto">
        
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            The Interoperability Layer
          </h2>
          <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
            Sleeve bridges diverse AI models, legacy systems, and platforms across air, land, and sea domains—designed for high-stakes, distributed environments.
          </p>
        </div>

        {/* Diagram */}
        <div 
          className="rounded-xl p-8 md:p-12 mb-16"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <div className="flex justify-center">
            <svg width="700" height="520" viewBox="0 0 700 520" className="max-w-full h-auto">
              
              {/* Top Row - Applications, Tools, Services */}
              {/* Applications - Hexagon */}
              <polygon 
                points="150,20 210,20 240,50 210,80 150,80 120,50" 
                fill="#242423" 
                stroke="#3A3A38" 
                strokeWidth="2"
              />
              <text x="180" y="55" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">APPLICATIONS</text>
              
              {/* Tools - Rounded Rectangle */}
              <rect x="300" y="25" width="100" height="50" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="2" />
              <text x="350" y="55" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">TOOLS</text>
              
              {/* Services - Hexagon */}
              <polygon 
                points="490,20 550,20 580,50 550,80 490,80 460,50" 
                fill="#242423" 
                stroke="#3A3A38" 
                strokeWidth="2"
              />
              <text x="520" y="55" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">SERVICES</text>
              
              {/* Top Bracket Connection */}
              <path 
                d="M 180 80 L 180 110 L 350 110" 
                stroke="#4FB3B8" 
                strokeWidth="2" 
                fill="none"
              />
              <path 
                d="M 520 80 L 520 110 L 350 110" 
                stroke="#4FB3B8" 
                strokeWidth="2" 
                fill="none"
              />
              <line x1="350" y1="80" x2="350" y2="110" stroke="#4FB3B8" strokeWidth="2" />
              <line x1="350" y1="110" x2="350" y2="150" stroke="#4FB3B8" strokeWidth="2" />
              
              {/* Configuration Rules */}
              <circle cx="350" cy="165" r="14" fill="#F5CB5C" />
              <g transform="translate(343, 158)">
                <path d="M7 4.5a.5.5 0 01.5-.5h0a.5.5 0 01.5.5v0a.5.5 0 01-.5.5h0a.5.5 0 01-.5-.5v0zM7 9.5a.5.5 0 01.5-.5h0a.5.5 0 01.5.5v0a.5.5 0 01-.5.5h0a.5.5 0 01-.5-.5v0z" fill="#242423"/>
                <circle cx="7.5" cy="7" r="5" stroke="#242423" strokeWidth="1.5" fill="none"/>
              </g>
              <text x="440" y="170" textAnchor="start" fill="#9CA3AF" fontSize="11" fontWeight="600" letterSpacing="1">CONFIGURATION RULES</text>
              
              {/* Line from Config to Interoperability Layer */}
              <line x1="350" y1="180" x2="350" y2="210" stroke="#4FB3B8" strokeWidth="2" />
              
              {/* Interoperability Layer - Main Box */}
              <rect x="170" y="210" width="360" height="90" rx="12" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
              <text x="350" y="250" textAnchor="middle" fill="#E8EDDF" fontSize="16" fontWeight="700" letterSpacing="2">INTEROPERABILITY LAYER</text>
              <text x="350" y="275" textAnchor="middle" fill="#9CA3AF" fontSize="13">Normalization &amp; Translation</text>
              
              {/* Incompatibility Exception */}
              <text x="230" y="340" textAnchor="end" fill="#9CA3AF" fontSize="10" fontWeight="600" letterSpacing="1">INCOMPATIBILITY EXCEPTION</text>
              <circle cx="250" cy="336" r="10" fill="#FF6B6B" />
              <text x="250" y="340" textAnchor="middle" fill="#242423" fontSize="10" fontWeight="bold">!</text>
              
              {/* Bottom Bracket Connection */}
              <line x1="350" y1="300" x2="350" y2="350" stroke="#4FB3B8" strokeWidth="2" />
              <line x1="140" y1="350" x2="560" y2="350" stroke="#4FB3B8" strokeWidth="2" />
              
              {/* Vertical lines to bottom nodes */}
              <line x1="140" y1="350" x2="140" y2="390" stroke="#4FB3B8" strokeWidth="2" />
              <line x1="280" y1="350" x2="280" y2="390" stroke="#4FB3B8" strokeWidth="2" />
              <line x1="420" y1="350" x2="420" y2="390" stroke="#4FB3B8" strokeWidth="2" />
              <line x1="560" y1="350" x2="560" y2="390" stroke="#4FB3B8" strokeWidth="2" />
              
              {/* Bottom Row Shapes */}
              {/* Legacy - Hexagon with gray stroke */}
              <polygon 
                points="140,390 100,410 100,450 140,470 180,450 180,410" 
                fill="#242423" 
                stroke="#9CA3AF" 
                strokeWidth="2"
              />
              <text x="140" y="435" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">LEGACY</text>
              
              {/* Edge - Rounded Rectangle with teal */}
              <rect x="220" y="400" width="120" height="50" rx="8" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
              <text x="280" y="430" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">EDGE</text>
              
              {/* Cloud - Hexagon with teal */}
              <polygon 
                points="420,390 380,410 380,450 420,470 460,450 460,410" 
                fill="#242423" 
                stroke="#4FB3B8" 
                strokeWidth="2"
              />
              <text x="420" y="435" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">CLOUD</text>
              
              {/* External APIs - Rounded Rectangle with gray */}
              <rect x="490" y="400" width="140" height="50" rx="8" fill="#242423" stroke="#9CA3AF" strokeWidth="2" />
              <text x="560" y="430" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600" letterSpacing="1">EXTERNAL APIs</text>
              
            </svg>
          </div>
        </div>

        {/* Bottom Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div>
            <h4 className="text-lg font-semibold mb-3" style={{ color: '#E8EDDF' }}>
              Model-Agnostic Orchestration
            </h4>
            <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
              Works with any AI model, ML framework, or inference engine. Sleeve orchestrates—it doesn't constrain model selection or implementation approach.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-3" style={{ color: '#E8EDDF' }}>
              Legacy System Compatible
            </h4>
            <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
              Protocol adapters for industrial standards: Modbus, OPC UA, CAN, MQTT, DDS. Integrate decades-old systems without replacement or modification.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-3" style={{ color: '#E8EDDF' }}>
              Cross-Domain Operations
            </h4>
            <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
              Single orchestration layer spans autonomous vehicles, factory automation, maritime operations, and defense networks without domain-specific customization.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default InteroperabilityLayerSection;